import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ProfilePerformance.css";
import SearchAppearancesCard from "./SearchAppearancesCard/SearchAppearancesCard";
import RecruiterActionsCard from "./RecruiterActionsCard/RecruiterActionsCard";
import ActivityLevelCard from "./ActivityLevelCard/ActivityLevelCard";
import ProfileScoreCard from "../View_Profile/ProfileScoreCard/ProfileScoreCard";

function ProfilePerformance() {
  return (
    <Container fluid className="profile-layout-wrapper profile-performance-dashboard py-4 px-0">
      <div className="container">
        <Row className="profile-layout-wrapper__row">
          {/* LEFT SIDEBAR */}
          <Col
            lg={3}
            md={4}
            sm={12}
            className="profile-layout-wrapper__sidebar"
          >
            <ActivityLevelCard />
            <hr/>
            <ProfileScoreCard />
          </Col>

          {/* RIGHT CONTENT */}
          <Col lg={9} md={8} sm={12} className="profile-layout-wrapper__main">
            <SearchAppearancesCard />
            <RecruiterActionsCard />
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default ProfilePerformance;
